export enum EnClipType {
    circle = 'circle',
    ellipse = 'ellipse',
    comment = 'comment',
    rectangle = 'rectangle',
    square = 'square'
}